module.exports = __webpack_public_path__ + "static/media/attendance-report-recording-icon.237e1b37.svg";